<div class="icon-container">
  <mat-icon svgIcon="icon-scribe" class="scribe-icon"></mat-icon>
</div>
